import React from 'react';

import { AnchorBlockData } from 'api/cms';
import Box from 'components/Box';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const AnchorBlock = ({ data: { anchor } }: { data: AnchorBlockData }) => (
  <Box component="a" data-qa-id={`anchor-block-${anchor}`} id={anchor} />
);

export default AnchorBlock;
